import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'question-creation-task';

const ELEMENTS = define({
  // `TaskStatusTag` is a plain `Label` with no role, and — unlike the QSet
  // Review tags — its text is `currentWorkflowStep.name` straight from the API
  // rather than a local constant. The same words also render as the task list's
  // filter tabs. Applied to both the owner and the my-task header; only one of
  // them is ever mounted, since they belong to different routes.
  STATUS_TAG: ['status', 'tag'],
  // The spec asserts this *disappears* once the task is finished, and a
  // hidden-element assertion should not hinge on a button label.
  FINISH_TASK_BUTTON: ['finish-task', 'button'],
});

export const QUESTION_CREATION_TASK_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
